import { createApp, h } from 'vue'
import { UAParser } from 'ua-parser-js'; 
import App from './App.vue'
import router from './router'
import store from './store'
import XLiteService from './services/XLiteService.js'
import { 
    showPrices, pricesVisibility, pricesDisplay, pricesTogglerVisibility, pricesTogglerDisplay, pricesTogglerPointer, onPriceClick,
    showCosts, costsVisibility, costsDisplay, costsTogglerVisibility, costsTogglerDisplay, costsTogglerPointer, onCostClick
 } from './utilities/PriceCostToggle.js'

import { library, dom } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { 
        faMagnifyingGlass,
        faTable,
        faBarcode,
        faBarcodeScan,
        faUpload,
        faPowerOff,
        faTrashCan,
        faSpinner,
        faCheck,
        faXmark,
        faImage,
        faImages,
        faImageSlash,
        faImageLandscape,
        faEuroSign,
        faCircleInfo,
        faClothesHanger,
        faSignature,
        faCalendarDay,
        faSunDust,
        faMoneyBillTrendUp,
        faMoneyBillWave,
        faTruck,
        faLocationDot,
        faHandHoldingBox,
        faFlag,
        faShirt,
        faPalette,
        faLayerGroup,
        faLayerPlus,
        faCalendarPlus,
        faCalendarPen,
        faFileCircleInfo,
        faLink,
        faLinkSlash,
        faGear,
        faUserClock,
        faPlus,
        faReceipt,
        faHashtag,
        faRuler,
        faChartMixed,
        faScrewdriverWrench,
        faCoins,
        faGaugeHigh as fasGaugeHigh,
        faServer,
        faListCheck,
        faSheetPlastic,
       } from '@fortawesome/pro-solid-svg-icons'
import { 
        faCamera,
        faCameraSlash,
        faTag,
        faTags,
        faBoxesStacked,
        faGaugeHigh,
        faChartUser,
        faChartPieSimple,
        faPencil,
        faLightbulbOn,
        faLightbulbSlash
       } from '@fortawesome/pro-regular-svg-icons'
import { faSlware } from "./assets/icons"
library.add(
		faTable,
		faBarcode,
		faBarcodeScan,
		faMagnifyingGlass,
		faCamera,
		faCameraSlash,
		faUpload,
		faPowerOff,
		faTrashCan,
		faSpinner,
		faCheck,
		faXmark,
		faImage,
		faImages,
        faImageSlash,
        faImageLandscape,
		faEuroSign,
		faTag,
		faTags,
		faBoxesStacked,
		faCircleInfo,
		faClothesHanger,
		faSignature,
		faSlware,
        faCalendarDay,
        faSunDust,
        faMoneyBillTrendUp,
        faMoneyBillWave,
        faTruck,
        faLocationDot,
        faHandHoldingBox,
        faFlag,
        faShirt,
        faPalette,
        faLayerGroup,
        faLayerPlus,
        faCalendarPlus,
        faCalendarPen,
        faFileCircleInfo,
        faLink,
        faLinkSlash,
        faGear,
        faUserClock,
        faPlus,
        faGaugeHigh,
        faChartUser,
        faReceipt,
        faHashtag,
        faRuler,
        faChartMixed,
        faChartPieSimple,
        faPencil,
        faScrewdriverWrench,
        faCoins,
        fasGaugeHigh,
        faServer,
        faListCheck,
        faLightbulbOn,
        faLightbulbSlash,
        faSheetPlastic
	)
dom.watch()

import { vue3Debounce } from 'vue-debounce'
import VueEasyLightbox from 'vue-easy-lightbox'

import PrimeVue from 'primevue/config'
import Accordion from 'primevue/accordion'
import AccordionTab from 'primevue/accordiontab'
import AutoComplete from 'primevue/autocomplete'
import Badge from 'primevue/badge'
import BadgeDirective from 'primevue/badgedirective'
import Button from 'primevue/button'
import Breadcrumb from 'primevue/breadcrumb'
import Calendar from 'primevue/calendar'
import Carousel from 'primevue/carousel'
import Chart from 'primevue/chart'
import Checkbox from 'primevue/checkbox'
import Chip from 'primevue/chip'
import Column from 'primevue/column'
import ConfirmDialog from 'primevue/confirmdialog'
import ContextMenu from 'primevue/contextmenu'
import DataTable from 'primevue/datatable'
import DataView from 'primevue/dataview'
import DataViewLayoutOptions from 'primevue/dataviewlayoutoptions'
import Dialog from 'primevue/dialog'
import Dropdown from 'primevue/dropdown'
import DynamicDialog from 'primevue/dynamicdialog'
import InlineMessage from 'primevue/inlinemessage'
import InputNumber from 'primevue/inputnumber'
import InputSwitch from 'primevue/inputswitch'
import InputText from 'primevue/inputtext'
import Menu from 'primevue/menu'
import Message from 'primevue/message'
import MultiSelect from 'primevue/multiselect'
import Paginator from 'primevue/paginator'
import Password from 'primevue/password'
import PickList from 'primevue/picklist'
import ProgressBar from 'primevue/progressbar'
import ProgressSpinner from 'primevue/progressspinner'
import RadioButton from 'primevue/radiobutton'
import Ripple from 'primevue/ripple'
import SelectButton from 'primevue/selectbutton'
import Sidebar from 'primevue/sidebar'
import Skeleton from 'primevue/skeleton'
import Slider from 'primevue/slider'
import SplitButton from 'primevue/splitbutton'
import StyleClass from 'primevue/styleclass'
import Tag from 'primevue/tag'
import Toast from 'primevue/toast'
import TabView from 'primevue/tabview'
import TabPanel from 'primevue/tabpanel'
import ToggleButton from 'primevue/togglebutton'
import Toolbar from 'primevue/toolbar'
import Tooltip from 'primevue/tooltip'
import TreeSelect from 'primevue/treeselect'

import ConfirmationService from 'primevue/confirmationservice'
import DialogService from 'primevue/dialogservice'
import ToastService from 'primevue/toastservice'

import 'primevue/resources/primevue.min.css'
import 'primeicons/primeicons.css'

import Access from './pages/Access'
import Error from './pages/Error'
import Login from './pages/Login'
import NotFound from './pages/NotFound'

// async iife to await the promise before creating the instance
(async() => {
    const authenticationType = await XLiteService.operatorInfo();
    const data = authenticationType.data;
    const li = data.li;
    await store.dispatch('setLi', { li }); // will also set .a correctly
    if (li === 'lasting') {
        // Operator is in a valid lasting session
        await store.dispatch('setOperator', data.operatorData);
        store.commit('INITIALISE_OPERATOR_PREFERENCES')
    }

    const app = createApp({
        computed: {
            ViewComponent () {
                switch (this.$route.path) {
                    case '/login':
                        return Login;
                    case '/error':
                        return Error;
                    case '/access':
                        return Access;
                    case '/notfound':
                        return NotFound;
                    default:
                        return App;
                }
            }
        },
        beforeCreate() {
            if(process.env.NODE_ENV === "development"){
                if(!localStorage.getItem('debug')){
                    localStorage.setItem('debug', 'xlite-web-client*')
                    location.reload()
                }
            } else {
                localStorage.removeItem('debug')
            }
        },
        render () { return h(this.ViewComponent) }
    })
    app.use(store)
    app.use(router)
    app.use(VueEasyLightbox)
    const uaparser = new UAParser()
    const isMobile = uaparser.getDevice().vendor == 'Apple' || uaparser.getDevice().type == 'tablet' || uaparser.getDevice().type == 'mobile'
    app.provide('isMobile', isMobile)
    app.provide('showPrices', showPrices)
    app.provide('pricesVisibility', pricesVisibility)
    app.provide('pricesDisplay', pricesDisplay)
    app.provide('pricesTogglerVisibility', pricesTogglerVisibility)
    app.provide('pricesTogglerDisplay', pricesTogglerDisplay)
    app.provide('pricesTogglerPointer', pricesTogglerPointer)
    app.provide('onPriceClick', onPriceClick)
    //
    app.provide('showCosts', showCosts)
    app.provide('costsVisibility', costsVisibility)
    app.provide('costsDisplay', costsDisplay)
    app.provide('costsTogglerVisibility', costsTogglerVisibility)
    app.provide('costsTogglerDisplay', costsTogglerDisplay)
    app.provide('costsTogglerPointer', costsTogglerPointer)
    app.provide('onCostClick', onCostClick)

    app.use(PrimeVue, {
        ripple: true,
        locale: {
            startsWith: 'Inizia con',
            contains: 'Contiene',
            notContains: 'Non contiene',
            endsWith: 'Finisce con',
            equals: 'Uguale a',
            notEquals: 'Diverso da',
            noFilter: 'Azzera filtri',
            lt: 'Minore di',
            lte: 'Minore o uguale di',
            gt: 'Maggiore di',
            gte: 'Maggiore o uguale di',
            dateIs: 'Date is',
            dateIsNot: 'Date is not',
            dateBefore: 'Date is before',
            dateAfter: 'Date is after',
            clear: 'Azzera',
            apply: 'Applica',
            matchAll: 'Corrispondenza totale',
            matchAny: 'Corrispondenza parziale',
            addRule: 'Aggiungi regola',
            removeRule: 'Rimuovi regola',
            accept: 'Sì',
            reject: 'No',
            choose: 'Scegli',
            upload: 'Upload',
            cancel: 'Annulla',
            dayNames: ["Domenica", "Lunedì", "Martedì", "Mercoledì", "Giovedì", "Venerdì", "Sabato"],
            dayNamesShort: ["Dom", "Lun", "Mar", "Mer", "Gio", "Ven", "Sab"],
            dayNamesMin: ["Do","Lu","Ma","Me","Gi","Ve","Sa"],
            monthNames: ["Gennaio","Febbraio","Marzo","Aprile","Maggio","Giugno","Luglio","Agosto","Settembre","Ottobre","Novembre","Dicembre"],
            monthNamesShort: ["Gen", "Feb", "Mar", "Apr", "Mag", "Giu","Lug", "Ago", "Set", "Ott", "Nov", "Dic"],
            today: 'Oggi',
            weekHeader: 'Set.',
            firstDayOfWeek: 1,
            dateFormat: 'dd/mm/yy',
            weak: 'Debole',
            medium: 'Medio',
            strong: 'Forte',
            passwordPrompt: 'Inserisci una password',
            emptyFilterMessage: 'Nessun risultato',
            emptyMessage: 'Nessuna opzione disponibile'
        }
    })
    app.use(ConfirmationService)
    app.use(DialogService)
    app.use(ToastService)

    app.directive('tooltip', Tooltip)
    app.directive('ripple', Ripple)
    app.directive('badge', BadgeDirective)
    app.directive('styleclass', StyleClass)
    app.directive('debounce', vue3Debounce({
        lock: false,                    //false
        listenTo: ['input', 'keyup'],   //keyup
        defaultTime: '300ms',           //300ms
        fireOnEmpty: true,              //false
        trim: true                      //false
        // Possible alternative with Vanilla JS:
        // https://stackoverflow.com/questions/1909441/how-to-delay-the-keyup-handler-until-the-user-stops-typing?rq=1
    }))

    app.component('Accordion', Accordion)
    app.component('AccordionTab', AccordionTab)
    app.component('AutoComplete', AutoComplete)
    app.component('Badge', Badge)
    app.component('Breadcrumb', Breadcrumb)
    app.component('Button', Button)
    app.component('Calendar', Calendar)
    app.component('Carousel', Carousel)
    app.component('Chart', Chart)
    app.component('Checkbox', Checkbox)
    app.component('Chip', Chip)
    app.component('Column', Column)
    app.component('ConfirmDialog', ConfirmDialog)
    app.component('ContextMenu', ContextMenu)
    app.component('DataTable', DataTable)
    app.component('DataView', DataView)
    app.component('DataViewLayoutOptions', DataViewLayoutOptions)
    app.component('Dialog', Dialog)
    app.component('Dropdown', Dropdown)
    app.component('DynamicDialog', DynamicDialog)
    app.component('Image', Image)
    app.component('InlineMessage', InlineMessage)
    app.component('InputNumber', InputNumber)
    app.component('InputSwitch', InputSwitch)
    app.component('InputText', InputText)
    app.component('Menu', Menu)
    app.component('Message', Message)
    app.component('MultiSelect', MultiSelect)
    app.component('Paginator', Paginator)
    app.component('Password', Password)
    app.component('PickList', PickList)
    app.component('ProgressBar', ProgressBar)
    app.component('ProgressSpinner', ProgressSpinner)
    app.component('RadioButton', RadioButton)
    app.component('SelectButton', SelectButton)
    app.component('Sidebar', Sidebar)
    app.component('Skeleton', Skeleton)
    app.component('Slider', Slider)
    app.component('SplitButton', SplitButton)
    app.component('TabView', TabView)
    app.component('TabPanel', TabPanel)
    app.component('Tag', Tag)
    app.component('Toast', Toast)
    app.component('ToggleButton', ToggleButton)
    app.component('Toolbar', Toolbar)
    app.component('TreeSelect', TreeSelect)

    app.component('font-awesome-icon', FontAwesomeIcon)

    app.mount('#app')
})()
.catch(() => {
    const app = createApp({
        render () { return h(Error) }
    })
    app.mount('#app')
});
